import { BillRepository } from "../../repositories/BillRepository";
import { BillOperationResult } from "../../entities/BillEntity";

/**
 * Delete Posted Bill Use Case
 * Deletes a bill that has been posted to Zoho (removes payments in Zoho, then deletes the bill, then soft-deletes locally)
 */
export class DeletePostedBillUseCase {
  constructor(private repository: BillRepository) {}

  async execute(billId: number): Promise<BillOperationResult> {
    return await this.repository.deletePostedBill(billId);
  }
}
